import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { QuestionsService } from '../../services/questions.service';

interface DashboardAction {
  title: string;
  description: string;
  icon: string;
  route?: string;
  queryParams?: Record<string, string>;
}

@Component({
  selector: 'app-ask-ayen-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  spinner: boolean = false;
  activeCohortName: string = '-';
  needReviewCount: number = 0;
  openQuestionsCount: number = 0;

  actions: DashboardAction[] = [
    {
      title: 'إدارة التخصصات',
      description: 'إضافة وتعديل التخصصات المرجعية الثمانية.',
      icon: 'assets/images/svg/grid-icon.svg',
      route: '/pages/ask-ayen/specialties',
    },
    {
      title: 'إدارة المجموعات',
      description: 'المجموعات والخبراء والتخصصات المرتبطة بها.',
      icon: 'assets/images/svg/company-icon.svg',
      route: '/pages/ask-ayen/cohorts',
    },
    {
      title: 'إدارة الأسئلة',
      description: 'استعراض جميع الأسئلة وحالاتها وإجاباتها.',
      icon: 'assets/images/svg/essential.svg',
      route: '/pages/ask-ayen/questions',
    },
    {
      title: 'المراجعة الإدارية المعلقة',
      description: 'الأسئلة التي تحتاج قراراً إدارياً.',
      icon: 'assets/images/svg/essential (2).svg',
      route: '/pages/ask-ayen/questions',
      queryParams: { tab: 'needsReview' },
    },
    {
      title: 'الرؤى / الإحصائيات',
      description: 'مؤشرات الأداء والتوزيع حسب التخصص والخبراء.',
      icon: 'assets/images/svg/business.svg',
    },
  ];

  private router = inject(Router);
  private titleService = inject(Title);
  private questionsService = inject(QuestionsService);

  ngOnInit(): void {
    this.titleService.setTitle('لوحة التحكم | أسأل عاين');
    this.loadStats();
  }

  loadStats(): void {
    this.spinner = true;

    this.questionsService.getDashboardSummary().subscribe({
      next: (response) => {
        const summary = response.data;
        this.activeCohortName = summary?.active_cohort?.name || '-';
        this.needReviewCount = summary?.under_review_questions_count || 0;
        this.openQuestionsCount = summary?.open_questions_count || 0;
        this.spinner = false;
      },
      error: () => {
        this.spinner = false;
      },
    });
  }

  goToAction(action: DashboardAction): void {
    if (!action.route) return;
    this.router.navigate([action.route], { queryParams: action.queryParams });
  }
}
